import { useQuery } from "@tanstack/react-query";
import { useHydrated } from "@tanstack/react-router";
import { createServerFn, createServerOnlyFn } from "@tanstack/react-start";
import { listingPageSchema } from "@wags/catalog/listings/listing-page.contract.ts";
import { getCatalog } from "@/lib/core/catalog-core.server";
import { ListingDetailInputSchema } from "./listing-detail.contract";

const getListingPageData = createServerOnlyFn(async (listingId: string) => {
    const catalog = await getCatalog();
    const page = await catalog.listings.getListingPage(listingId);
    return page ? listingPageSchema.parse(page) : null;
});

const getListingPage = createServerFn({ method: "GET" })
    .inputValidator((listingId: string) =>
        ListingDetailInputSchema.shape.listingId.parse(listingId),
    )
    .handler(async ({ data }) => getListingPageData(data));

export async function fetchListingPage(listingId: string) {
    return getListingPage({ data: listingId });
}

export function useListingPageV2(
    listingId: string | undefined,
    enabled: boolean,
) {
    const hydrated = useHydrated();
    const { data, isLoading } = useQuery({
        queryKey: ["listing-page-v2", listingId],
        enabled: enabled && listingId !== undefined,
        queryFn: () => fetchListingPage(listingId ?? ""),
        staleTime: 5 * 60 * 1000,
        retry: false,
    });
    return {
        data: data ?? null,
        isPending: data == null && (!hydrated || isLoading),
    };
}
